import { NavLink, useLocation } from "react-router";

export default function NavbarLink(props: any) {
  
  const location = useLocation();
  const isActive = location.pathname == props.href

  return (
    <NavLink to={props.href} className={`py-3 px-4 lg:text-white`} >
      {props.title}
    </NavLink>
  )
}